export default "__VITE_ASSET__2iZzlA7T__"